export var POWERS10 = [
    1 /* Constants.P0 */,
    10 /* Constants.P1 */,
    100 /* Constants.P2 */,
    1000 /* Constants.P3 */,
    10000 /* Constants.P4 */,
    100000 /* Constants.P5 */,
    1000000 /* Constants.P6 */,
    10000000 /* Constants.P7 */,
    100000000 /* Constants.P8 */,
];
//# sourceMappingURL=types.js.map